import { render, staticRenderFns } from "./TemplateSelectorComponent.vue?vue&type=template&id=93466918&scoped=true"
import script from "./TemplateSelectorComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateSelectorComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TemplateSelectorComponent.vue?vue&type=style&index=0&id=93466918&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93466918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93466918')) {
      api.createRecord('93466918', component.options)
    } else {
      api.reload('93466918', component.options)
    }
    module.hot.accept("./TemplateSelectorComponent.vue?vue&type=template&id=93466918&scoped=true", function () {
      api.rerender('93466918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/TemplateSelectorComponent/TemplateSelectorComponent.vue"
export default component.exports